﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import InsuranceHeading from './InsuranceHeading';
import StatusBlock from './StatusBlock';
import {ListingWrapper, Header, StatusCtaWrapper, StatusBlockColumn} from './statusBlockComponents';

import Form from '../../../../vendor/react-validation/components/form';
import {required} from '../../../Forms/Validation/rules';
import getFormValues from '../../../Forms/getFormValues';

import ValidationButton from '../../../Forms/Components/ValidationButton';
import RadioButton from '../../../Forms/Components/RadioButton';
import HiddenInput from '../../../Forms/Components/HiddenInput';

import {redirectToHealthDeclarationForAction} from '../../../State/actions';

class MultipleRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.form = null;
    }

    static get propTypes() {
        return {
            registrations: PropTypes.array.isRequired
        }
    }

    handleFormSelection = (e) => {
        e.preventDefault();
        const { insuranceName, insuranceObjectId } = getFormValues(this.form);
        this.props.redirectToHealthDeclarationFor(insuranceName, insuranceObjectId);
    }

    render() {
        const registrations = this.props.registrations;
        const registrationsMarkedForRisk = registrations.filter((registration, index) => {
            return registration.markedForRisk;
        });
        const showOnlyMarkedForRisk = registrationsMarkedForRisk.length;
        const status = showOnlyMarkedForRisk ? 'pending' : 'notStarted';

        return (
            <ListingWrapper>
                <Form ref={el => { this.form = el; }} onSubmit={this.handleFormSelection}>
                    <Header>
                        {!showOnlyMarkedForRisk && 
                            <Heading>Välj en ansökning att slutföra</Heading>}

                        {registrations.map((registration, i) => {
                            const markedForRisk = registration.markedForRisk;

                            if (markedForRisk) {
                                return (
                                    <div key={i}>
                                        <InsuranceHeading registration={registration} />
                                    </div>
                                );
                            }

                            if (showOnlyMarkedForRisk) {
                                return;
                            }

                            return (
                                <div key={i}>
                                    <RadioButton 
                                        id={registration.insuranceName}
                                        name="insuranceName"
                                        value={registration.insuranceName}
                                        validations={[required]}
                                        displayname={<InsuranceHeading registration={registration}/>}
                                        data-validation-error-message={i == this.props.registrations.length - 1 ? 'Välj en ansökning att slutföra' : ''}
                                        customdisplay="inline-block"
                                        marginbottom="10px"
                                        customwidth="100%"
                                    />
                                    <HiddenInput
                                        id={`${registration.insuranceName}-objectId`}
                                        name="insuranceObjectId"
                                        value={registration.insuranceObjectId}
                                    />
                                </div>
                            );
                        })} 
                    </Header>
                    <StatusCtaWrapper>
                        <StatusBlockColumn align="left">
                            <StatusBlock status={status} />
                        </StatusBlockColumn>
                        {!showOnlyMarkedForRisk &&
                            <StatusBlockColumn align="right">
                                <ValidationButton 
                                    onMouseEnter={() => this.validationTimer = setTimeout(this.form.validateAll, 1000)}
                                    onMouseLeave={() => clearTimeout(this.validationTimer)}
                                    topMargin="0"
                                    noIcon
                                >
                                    Fyll i hälsoprövning
                                </ValidationButton>
                            </StatusBlockColumn>}
                    </StatusCtaWrapper>
                </Form>
            </ListingWrapper>
        );      
    }
}

// state

const mapDispatchToProps = (dispatch) => {
    return {
        redirectToHealthDeclarationFor: (insuranceName, insuranceObjectId) => dispatch(redirectToHealthDeclarationForAction(insuranceName, insuranceObjectId))
    };
};

export default connect(() => ({}), mapDispatchToProps)(MultipleRegistration);

// styles

const Heading = styled.h3`
    margin-bottom: 18px;

    font-size: 18px;
    ${mediaQuery.large(`
        font-size: 16px;
    `)}
`;